import { zManufacturerCommonSchema } from "./manufacturer.common";
// Доменная схема для Manufacturer (может быть расширена связанными данными)
export const zManufacturerSchemaDom = zManufacturerCommonSchema;
export const zManufacturerSchemaCreateDom = zManufacturerSchemaDom.omit({
    id: true,
});
